<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else class="block">
    <h3 class="m-t-0">{{$query.file_uid ? '编辑文件' : '添加文件'}}</h3>
    <el-form ref="form" :model="form" :rules="rules" label-width="6em" label-position="left">
      <el-form-item label="部门" prop="department_uid">
        <el-select v-model="form.department_uid" placeholder="选择部门" class="full-width">
          <el-option v-for="department in departments" :label="department.name"
                     :value="department.uid" :key="department.uid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件" prop="file">
        <el-upload drag action="none" :auto-upload="false"
                   :file-list="form.file ? [form.file]: []" :on-change="changeFile" :on-remove="removeFile"
                   class="full-width">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text l-h-1_5">
            将文件拖到此处，或<em>点击上传</em>
            <div v-if="form.file">再次选择文件可替换文件</div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="说明" prop="desc">
        <el-input type="textarea" v-model="form.desc" :autosize="{minRows: 3}"></el-input>
      </el-form-item>
      <el-form-item label="全校共享" prop="public">
        <el-radio-group v-model="form.public">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="m-v-10 text-center">
        <el-button type="primary" size="cons" @click="submit()" :loading="submit_loading>0">提交</el-button>
        <el-button type="default" size="cons" @click="$router.back()" :loading="submit_loading>0">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import assign from 'lodash/assign'
import * as Storage from 'api/storage'

export default {
  data () {
    return {
      ready: false,
      form: {
        department_uid: '',
        file: null,
        desc: '',
        'public': false,
      },
      rules: {
        department_uid: [this.$rules.required('部门为必选项')],
        file: [this.$rules.required({message: '必须选择文件', type: 'object'})],
      },
      departments: null,
      submit_loading: 0,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [departments, file] = await Promise.all([
          Storage.user_department_list({user_uid: this.$user.uid}),
          this.$query.file_uid ? Storage.get({uid: this.$query.file_uid}) : null,
        ])
        if (file) {
          this.form = {
            department_uid: file.department_uid,
            file: {name: file.name, url: file.url, server: true},
            desc: file.desc,
            'public': !!file.public,
            uid: file.uid,
          }
        }
        this.departments = departments
        if (!this.$query.file_uid && this.$query.department_uid) {
          let department = this.departments.find(department => department.uid === this.$query.department_uid)
          if (department) this.form.department_uid = this.$query.department_uid
        }
        this.ready = true
      })
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        let form = assign({}, this.form)
        if (form.file.server) delete form.file
        await Storage.edit(this.form)
        this.$message.success('文件添加成功')
        this.$router.back()
      })
    },
    changeFile (file) {
      this.form.file = file.raw
      this.$validate(this.$refs.form, 'file')
    },
    removeFile () {
      this.form.file = null
      this.$validate(this.$refs.form, 'file')
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
.block {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/file/FileEdit.vue